import * as React from 'react'
import QuestionCircle from 'static/images/tooltip/question-circle.svg'

import OverlayTrigger, { IExternalProps as OverlayTriggerInterface } from '../../common/OverlayTrigger/OverlayTrigger'
import './Tooltip.scss'

const className = 'ReactTooltip'

interface IExternalProps {
  placement: OverlayTriggerInterface['placement']
  header: {
    title?: string | React.ReactNode
    body: string | React.ReactNode
    showCloseIcon?: boolean
  }
  analytics?: {
    call: (analyticKey: string) => void
    key: string
  }
  onClose?: () => void
}

interface ITooltipProps extends IExternalProps {
  bodyJSX: JSX.Element
}

export const Tooltip: React.FC<ITooltipProps> = (props) => {
  const [showTooltip, setShowTooltip] = React.useState<boolean>(!!props.header.showCloseIcon)
  const onClose = props.onClose || (() => {})

  return (
    <OverlayTrigger
      popperClassName={className}
      placement={props.placement}
      show={showTooltip}
      overlay={
        <div className={`${className}__overlay`}>
          {props.header.showCloseIcon && (
            <div
              className={'closeIcon'}
              onClick={() => {
                setShowTooltip(false)
                onClose()
              }}
            >
              x
            </div>
          )}
          {props.header.title && <h2 className={`${className}__header`}>{props.header.title}</h2>}
          <div className={`${className}__body`}>{props.header.body}</div>
        </div>
      }
    >
      <div
        className={`${className}__hoverArea`}
        onMouseOverCapture={() => {
          if (props.analytics) {
            props.analytics.call(props.analytics.key)
          }
          setShowTooltip(true)
        }}
        onMouseOutCapture={() => {
          setShowTooltip(false)
          onClose()
        }}
      >
        {props.bodyJSX}
      </div>
    </OverlayTrigger>
  )
}

export const HelpTooltip = (props: IExternalProps) => (
  <Tooltip
    placement={props.placement}
    header={props.header}
    analytics={props.analytics}
    bodyJSX={<img className={`${className}__help-image`} src={QuestionCircle} />}
    onClose={props.onClose}
  />
)
